import { useState, useEffect, useRef } from "react";
import { getAreas, getCountries } from "../../utils/SonicAPI";

import toast from "react-hot-toast";

import { useContext } from "react";

import LocationSelector from "./LocationSector";

import generateSecretKey from "../../utils/keyGenerationUtils";
import { encryptDataBase64 } from "../../utils/encryptionUtils";
import { decryptDataBase64 } from "../../utils/decryptionUtils";
import { UserContext } from "../../context/user.context";
import {
  saveDeliveryLocation,
  updateDeliveryLocation,
} from "../../utils/zulalWebAPI";

const AddressForm = ({ mode, address, onClose }) => {
  const { sonicAccessToken, currentUser } = useContext(UserContext);

  // const fetchAreas = async (cityID, token) => {
  //   if (!cityID) return;
  //   //console.log(`token from Mosque Selection ${token}`);

  //   try {
  //     const response = await getAreas(cityID, token);

  //     //console.log("Fetched Areas:", response);
  //     setAreaData(response.data); // Ensure the API response is in the correct format
  //     areaObj.current.enabled = true;
  //     areaObj.current.dataBind();
  //   } catch (error) {
  //     alert(
  //       "No Area Found! We are updating our Areas List, please select other city"
  //     );
  //     console.error(
  //       "No Area Found! We are updating our Areas List, please select other city",
  //       error
  //     );
  //   }
  // };

  const [formData, setFormData] = useState({
    locationLabel: "",
    recipientName: "",
    phoneNumber: "",
    buildingName: "",
    flatNumber: "",
    landmark: "",
    country: "",
    state: "",
    city: "",
    area: "",
    customerCode: "",
    isDefault: false,
  });
  const [locationValues, setLocationValues] = useState({});

  useEffect(() => {
    if (mode === "edit" && address) {
      console.log("Edit Form");
      console.log(address);
      setFormData(address);
      // Prepare location values
      setLocationValues({
        country: {
          countryId: address.countryId,
          countryName: address.countryName,
        },
        state: {
          stateId: address.stateId,
          stateCode: address.stateCode,
          statessName: address.statessName,
        },
        city: { cityId: address.cityId, cityName: address.cityName },
        area: { areaId: address.areaId, areaName: address.areaName },
      });
      console.log("Location Values from Edit:", locationValues.country);
    }
  }, [mode, address]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLocationChange = (location) => {
    setLocationValues(location);
    console.log(`location from handle Location Change:${location}`);

    // Use a functional update to ensure the latest state is reflected
    setFormData((prev) => ({
      ...prev,
      country: location.country,
      state: location.state,
      city: location.city,
      area: location.area,
      customerCode: currentUser.customerCode,
    }));

    // Debug logs
    console.log("Updated formData:", {
      ...formData,
      country: location.country,
      state: location.state,
      city: location.city,
      area: location.area,
      customerCode: currentUser.customerCode,
    });
  };

  const handleSubmit = async () => {
    const secretKey = generateSecretKey();
    console.log(secretKey);

    const encryptedCustomerInfo = encryptDataBase64(formData, secretKey);

    const encryptedData = {
      secretKey: secretKey,
      encrypteCustomerInfo: encryptedCustomerInfo,
    };

    if (mode === "edit") {
      // Call update API

      console.log(JSON.stringify(formData));
      console.log(encryptedData);

      const response = await updateDeliveryLocation(encryptedData);

      console.log(response);

      if (response.status === "success") {
        toast.success("Address updated successfully");
        onClose(); // hide form
      } else {
        // keep open the form with values
        setFormData({
          ...formData,
          country: locationValues.country,
          state: locationValues.state,
          city: locationValues.city,
          area: locationValues.area,
          customerCode: currentUser.customerCode,
        });
      }
    } else {
      // Call add / save API

      console.log(formData);
      console.log(encryptedData);
      const response = await saveDeliveryLocation(encryptedData);
      console.log(response);

      if (response.status === "success") {
        toast.success("Address saved successfully");
        onClose(); // hide form
      } else {
        // keep open the form with values
        setFormData({
          ...formData,
          country: locationValues.country,
          state: locationValues.state,
          city: locationValues.city,
          area: locationValues.area,
          customerCode: currentUser.customerCode,
        });

        // re-open the same form with mode === "new"
        toast.error("Error saving address");
      }
    }
  };

  return (
    <div>
      <div className="mx-auto mr-4 ml-4 mb-28">
        <div className="bg-white border border-cool-gray-400 p-4 rounded-xl shadow-md space-y-3">
          <div className="text-navarbarText text-3xl font-poppins font-medium mb-8">
            <h2 className="text-lg font-semibold">
              {mode === "edit" ? "Edit Address" : "Add New Address"}
            </h2>
            <p className="text-base text-darkTextColor font-poppins font-normal">
              Please update your current Location to serve you better
            </p>
          </div>
          <div>
            <label>Select Your area </label>

            <LocationSelector
              sonicAccessToken={sonicAccessToken}
              onLocationChange={handleLocationChange}
              initialLocationValues={locationValues} // Pass location values as props
            />
          </div>
          <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
            {/**     [LocationLabel] NVARCHAR (100) NULL, Name  */}
            <div>
              <label
                htmlFor="locationLabel"
                className="block text-sm font-semibold leading-6 text-gray-900"
              >
                Location Label
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="locationLabel"
                  placeholder="e.g. Home, Office"
                  value={formData.locationLabel}
                  onChange={handleChange}
                  id="locationLabel"
                  autoComplete="locationLabel"
                  className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-secondaryHover
                           placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            {/** Recipient Name  */}
            <div>
              <label
                htmlFor="recipientName"
                className="block text-sm font-semibold leading-6 text-gray-900"
              >
                Recipient Name
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="recipientName"
                  placeholder="e.g. Mohammed Ali"
                  value={formData.recipientName}
                  onChange={handleChange}
                  id="recipientName"
                  autoComplete="recipientName"
                  className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-secondaryHover
     placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            {/** Phone Number  */}
            <div>
              <label
                htmlFor="phoneNumber"
                className="block text-sm font-semibold leading-6 text-gray-900"
              >
                Phone Number
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="phoneNumber"
                  placeholder="e.g. 1234567890"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  id="phoneNumber"
                  autoComplete="phoneNumber"
                  className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-secondaryHover
     placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            {/** Building Name  */}
            <div>
              <label
                htmlFor="buildingName"
                className="block text-sm font-semibold leading-6 text-gray-900"
              >
                Building Name
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="buildingName"
                  placeholder="e.g. Green Valley"
                  value={formData.buildingName}
                  onChange={handleChange}
                  id="buildingName"
                  autoComplete="buildingName"
                  className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-secondaryHover
     placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            {/** Flat nuumber  */}
            <div>
              <label
                htmlFor="flatNumber"
                className="block text-sm font-semibold leading-6 text-gray-900"
              >
                Flat / Villa Number
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="flatNumber"
                  placeholder="e.g. 101"
                  value={formData.flatNumber}
                  onChange={handleChange}
                  id="flatNumber"
                  autoComplete="flatNumber"
                  className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-secondaryHover
         placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            {/** landmark Name  */}
            <div>
              <label
                htmlFor="landmark"
                className="block text-sm font-semibold leading-6 text-gray-900"
              >
                Nearby Landmark
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="landmark"
                  placeholder="e.g. Near Park"
                  onChange={handleChange}
                  value={formData.landmark}
                  id="landmark"
                  autoComplete="landmark"
                  className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-secondaryHover
             placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            {/**  isDefault checkbox   */}
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="isDefault"
                checked={formData.isDefault}
                onChange={(e) =>
                  setFormData({ ...formData, isDefault: e.target.checked })
                }
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <label htmlFor="isDefault" className="text-sm text-gray-700">
                Set as default location
              </label>
            </div>
          </div>

          <div className="mt-8 flex justify-end">
            <button
              type="button"
              onClick={handleSubmit}
              className="rounded-md bg-secondary  px-3.5 py-2.5 text-center text-sm font-medium text-textWhite shadow-sm hover:bg-secondaryHover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Save Location
            </button>

            <button
              onClick={onClose}
              className="bg-gray-300 text-black px-4 py-2 rounded"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressForm;
